import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  ICreateAssetTypesRequest,
  IGetAssetTypesByIdRequest,
  IUpdateAssetTypesRequest,
  TGetAssetTypesRequest,
  TGetAssetTypesResponse,
  TSingleAssetTypesResponse,
} from "@/types/(company)/assetTypes.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyAssetTypesApi = createApi({
  reducerPath: "companyAssetTypesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getAssetTypes"],
  endpoints: (builder) => ({
    getAssetTypes: builder.query<TGetAssetTypesResponse, TGetAssetTypesRequest>(
      {
        query: () => {
          return {
            url: "/company/asset-types/all",
            method: "GET",
          };
        },
        providesTags: ["getAssetTypes"],
      }
    ),
    createAssetTypes: builder.mutation<
      TSingleAssetTypesResponse,
      ICreateAssetTypesRequest
    >({
      query: (body) => {
        return {
          url: "/company/asset-types",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["getAssetTypes"],
    }),
    getAssetTypesById: builder.query<
      TSingleAssetTypesResponse,
      IGetAssetTypesByIdRequest
    >({
      query: (param) => {
        return {
          url: "/company/asset-types/" + param.id,
          method: "GET",
        };
      },
      providesTags: ["getAssetTypes"],
    }),
    updateAssetTypes: builder.mutation<
      TSingleAssetTypesResponse,
      IUpdateAssetTypesRequest
    >({
      query: ({ id, ...body }) => {
        return {
          url: "/company/asset-types/" + id,
          method: "PUT",
          body: body.data,
        };
      },
      invalidatesTags: ["getAssetTypes"],
    }),
    deleteAssetTypes: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: "/company/asset-types/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["getAssetTypes"],
    }),
  }),
});

export const {
  useGetAssetTypesQuery,
  useCreateAssetTypesMutation,
  useGetAssetTypesByIdQuery,
  useUpdateAssetTypesMutation,
  useDeleteAssetTypesMutation,
} = companyAssetTypesApi;
